import { render, staticRenderFns } from "./EnviosAutomaticos.vue?vue&type=template&id=59dcd14a"
import script from "./EnviosAutomaticos.vue?vue&type=script&lang=ts"
export * from "./EnviosAutomaticos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports